import { Button } from "@/components/ui";
import Input from '@/components/ui/Input/Input';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

const FormDataSchema = z.object({
  socialOne: z.string(),
  socialTwo: z.string(),
  socialThree: z.string()
});


const FooterSocialLinksForm = ({handleSave, handleCancel, data}:{handleSave: (data: {socialOne: string; socialTwo: string; socialThree: string; }) => void; handleCancel: () => void; data: z.infer<typeof FormDataSchema> }) => {
    
    const {
            control,
            handleSubmit,
            formState: { errors },
            reset
          } = useForm({
            resolver: zodResolver(FormDataSchema),
            defaultValues: {
              socialOne: data.socialOne ?? '',
              socialTwo: data.socialTwo ?? '',
              socialThree: data.socialThree ?? ''
            },
            mode: 'all'
          });
        
    return (
      <div className="flex flex-col gap-4 w-full p-4 lg:p-8 bg-[#F2F2F2]">
        <form onSubmit={handleSubmit(handleSave)} className="flex flex-col gap-4">
          <Controller
          name="socialOne"
          control={control}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="URL"
              label="Social One"
              error={errors.socialOne?.message}
              $dataId="socialOne-input"
              
            />
          )}
        />

           <Controller
          name="socialTwo"
          control={control}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="URL"
              label="Social Two"
              error={errors.socialTwo?.message}
              $dataId="socialTwo-input"
            />
          )}
        />

            <Controller
          name="socialThree"
          control={control}
          render={({ field }) => (
            <Input
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              placeholder="URL"
              label="Social Three"
              error={errors.socialThree?.message}
              $dataId="socialThree-input"
            />
          )}
        />
           
    

            <div className="flex gap-2 justify-end mt-4">
            <Button
              variant="secondary"
              className=""
              onClick={() => {
                handleCancel();
                reset();
              }}
            >
              Cancel
            </Button>
            <Button
              className=""
              onClick={handleSubmit(handleSave)}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    )
  };

  export default FooterSocialLinksForm;